import { IGroupFixture } from "core-integration/src/store/fixtures/types";
import { getTeamsById } from "core-integration/src/store/teams/reducers";
import { useContext, useState } from "react";
import { useSelector } from "react-redux";
import { usePlosTranslations } from "../../../contexts/PlosTranslationsContext";
import LiveIndicator from "../../../img/icons/live-indicator.svg?react";
import { Badge } from "../../Badge";
import { UnstyledRACButton } from "../../buttons/UnstyledRACButton";
import BroadcasterInfo from "./BroadcasterInfo";
import {
  fixtureBadge,
  fixtureScore,
  fixtureStyles,
  liveContainer,
  matchCard,
  matchTimeIndicator,
  team,
  teamH,
  teamName,
  teams,
} from "./fixture.css";
import { FixtureBroadcastersContext } from "./FixtureBroadcasters";
import FixtureTime from "./FixtureTime";
import { FixtureProps } from "./types";

const getMatchStatusElement = (
  fixture: IGroupFixture,
  fixtureTimeAbbreviation: string,
) => {
  if (fixture.finished_provisional) {
    return (
      <span className={matchTimeIndicator}>{fixtureTimeAbbreviation}</span>
    );
  }

  if (fixture.started) {
    return (
      <div className={matchTimeIndicator}>
        <div className={liveContainer}>
          <LiveIndicator />
          {fixture.minutes}'
        </div>
      </div>
    );
  }

  return null;
};

const Fixture = ({ fixture, inDisclosure }: FixtureProps) => {
  const { fixtures } = usePlosTranslations();
  const [dialogOpen, setDialogOpen] = useState(false);
  const teamsById = useSelector(getTeamsById);
  const fb = useContext(FixtureBroadcastersContext);
  const broadcasterInfo =
    fixture.event && fb[fixture.event] && fb[fixture.event][fixture.code]
      ? fb[fixture.event][fixture.code]
      : null;
  const fixtureStarted = fixture.started && fixture.team_h_score !== null;
  const matchCardContent = (
    <>
      <div className={teams}>
        <div className={teamH}>
          <span className={teamName}>{teamsById[fixture.team_h].name}</span>
          <div className={fixtureBadge}>
            <Badge isPresentation team={teamsById[fixture.team_h]} />
          </div>
        </div>
        {fixtureStarted ? (
          <div
            className={
              fixture.finished_provisional
                ? fixtureScore.finished
                : fixtureScore.notFinished
            }
          >
            <span>
              {fixture.team_h_score} - {fixture.team_a_score}
            </span>
          </div>
        ) : (
          <FixtureTime fixture={fixture} />
        )}
        <div className={team}>
          <div className={fixtureBadge}>
            <Badge isPresentation team={teamsById[fixture.team_a]} />
          </div>
          <span className={teamName}>{teamsById[fixture.team_a].name}</span>
        </div>
      </div>
      {getMatchStatusElement(fixture, fixtures.fixtureTimeAbbreviation)}
    </>
  );

  return (
    <div
      className={
        fixtureStarted ? fixtureStyles.isStarted : fixtureStyles.default
      }
    >
      {fixtureStarted && inDisclosure ? (
        <UnstyledRACButton className={matchCard} slot="trigger">
          {matchCardContent}
        </UnstyledRACButton>
      ) : (
        <div className={matchCard}>{matchCardContent}</div>
      )}

      {broadcasterInfo && (
        <BroadcasterInfo
          broadcasterInfo={broadcasterInfo}
          dialogOpen={dialogOpen}
          setDialogOpen={setDialogOpen}
        />
      )}
    </div>
  );
};

export default Fixture;
